var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('strong',{staticClass:"seat-label"},[(_vm.player)?_c('span',{staticClass:"player",class:_vm.position},[_vm._v(_vm._s(_vm.playerLabel))]):_c('PositionDisplay',{attrs:{"position":_vm.position}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }